// Who may see what, shared so the Worker's check and the screens that hide things agree.

import type { SessionInfo } from "./types";

/**
 * A kid's taps and their reasons: every grown-up, and that kid. Siblings see each other's
 * scores, stars, days and history, but not why each point moved.
 */
export function canSeeTaps(me: SessionInfo, kidId: string): boolean {
  return me.role === "adult" || me.kidId === kidId;
}
